<div
  class="app-search-box"
  [class.app-search-box--focused]="isFocused"
  [class.app-search-box--disabled]="disabled"
  [class.app-search-box--has-value]="!!value"
  [ngClass]="customClass"
  [style.width]="width || null"
  [style.maxWidth]="maxWidth || null"
  [style.height]="height || '36px'"
>
  <!-- Search Icon -->
  <span class="app-search-box__icon">
    <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.5 17.5L13.875 13.875"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </span>

  <!-- Input Field -->
  <input
    #searchInput
    type="text"
    class="app-search-box__input"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [readonly]="readonly"
    [autofocus]="autoFocus"
    [ngModel]="value"
    (ngModelChange)="onModelChange($event)"
    (focus)="onFocus($event)"
    (blur)="onBlur($event)"
    (keyup)="onKeyup($event)"
    autocomplete="off"
  />

  <!-- Clear Button -->
  <button
    *ngIf="clearable && value && !disabled && !readonly"
    type="button"
    class="app-search-box__clear"
    (click)="handleClear()"
    tabindex="-1"
    aria-label="Clear search"
  >
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  </button>
</div>
